import React from 'react';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import { toJS } from 'mobx';
import { Row, Col, Button, Input, DatePicker, Select } from 'antd';

const { Option } = Select; 

@inject('ecodeGenreStore')
@observer
class App extends React.Component {
  static defaultProps = {
		prefixCls: 'ecode-genre-search',
  }
  render() {
    const {
			prefixCls,
			formPrefixCls,
			ecodeGenreStore: {
        setState,
        searchValue,
        getGenreList,
			},
		} = this.props;
		const wrapCls = classNames({
			[`${prefixCls}`]: true,
			'sys-ecode-search': true,
		})
    return (
			<div className={wrapCls}>
        <Row>
          <Col span={3} className={`${prefixCls}-row`}>
            <Select defaultValue="genre">
              <Option value="genre">行业搜索</Option>
              <Option value="func" disabled>
                职能搜索
              </Option>
            </Select>
          </Col>
          <Col span={9} className={`${prefixCls}-row`}>
            <Input className={`${prefixCls}-row-input`} value={searchValue} onPressEnter={() => getGenreList({name: searchValue})} onChange={e => setState({searchValue: e.target.value})} placeholder="请输入行业名称" />
          </Col>
          <Col span={12} className={`${prefixCls}-row search-btns`}>
            <Button onClick={() => getGenreList({name: searchValue})} type="primary">搜索</Button>
            <Button onClick={() => setState({visible: true, editTitle: 'genre_add'})}>添加行业</Button>
          </Col>
        </Row>
			</div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/sys/ecodeGenre/Search.js